import { UseFormSetValue } from 'react-hook-form';

type Language = {
  id: string;
  label: string;
};
const setDefaultLanguageValues = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: UseFormSetValue<any>,
): void => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  import('@apps/localization/services/country').then((api: any) => {
    api.default.languages().then((result: { data: Language[] }) => {
      result.data.forEach((lang: Language, idx: number) => {
        setValue(`translations.${idx}.language_code`, lang.id);
      });
    });
  });
};

export { setDefaultLanguageValues };
